export const USER_SET_IS_LOGIN = "USER_SET_IS_LOGIN";

export const USER_INIT = "USER_INIT";

export const USER_TOKEN_REFRESH = "USER_TOKEN_REFRESH";

export const USER_GET_PERMISSIONS = "USER_GET_PERMISSIONS";
export const USER_SET_PERMISSIONS = "USER_SET_PERMISSIONS";

export const USER_GET_PROFILE = "USER_GET_PROFILE";
export const USER_SET_PROFILE = "USER_SET_PROFILE";
export const USER_PATCH_PROFILE = "USER_PATCH_PROFILE";
export const USER_PROFILE_SET_ERROR = "USER_PROFILE_SET_ERROR";

export const GET_USER_SETTINGS = "GET_USER_SETTINGS"
export const SET_USER_SETTINGS = "SET_USER_SETTINGS"
export const PATCH_USER_SETTINGS = "PATCH_USER_SETTINGS"
export const SHOW_USER_SETTINGS_LOADER = "SHOW_USER_SETTINGS_LOADER"
export const HIDE_USER_SETTINGS_LOADER = "HIDE_USER_SETTINGS_LOADER"
